<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="增加生产单元" name="first">
      <div class="addPond_form">
        <el-form ref="form" :model="form" label-width="120px" class="demo-ruleForm">
          <el-form-item label="*生产单元名称">
            <el-input v-model="form.cell_name" placeholder="自定义"></el-input>
          </el-form-item>
          <el-form-item label="*生产单元类型">
            <el-select v-model="form.cell_type" placeholder="请选择生产单元类型" >
              <div v-for="(cellType,index) in listCellType" :key="index">
                <el-option :label="cellType.desc" :value="cellType.celltype"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="*农产品">
            <el-select v-model="form.cell_prod" placeholder="请选择生产单元类型下的农产品" @click="getCellProd()">
              <div  v-for="(cellProd,index) in listCellProd" :key="index">
                <el-option :label="cellProd" :value="cellProd"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="*生产单元长度">
            <el-input v-model="form.cell_length" placeholder="单位(米)"></el-input>
          </el-form-item>
          <el-form-item label="*生产单元宽度">
            <el-input v-model="form.cell_width"  placeholder="单位(米)"></el-input>
          </el-form-item>
          <el-form-item label="*生产单元经度">
            <el-input v-model="form.cell_longitude" placeholder="可通过百度地图查看"></el-input>
          </el-form-item>
          <el-form-item label="*生产单元纬度">
            <el-input v-model="form.cell_latitude" placeholder="可通过百度地图查看"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定增加</el-button>
            <el-button @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      form: {
        cell_name: '',
        cell_length: '',
        cell_width: '',
        cell_type: '',
        cell_longitude: '',
        cell_latitude: '',
        cell_prod: ''
      },
      listCellType: {},
      listCellProd: {}
    }
  },
  methods: {
    onSubmit () {
      let formdata = new FormData()
      formdata.append('length', this.form.cell_length)
      formdata.append('width', this.form.cell_width)
      formdata.append('longitude', this.form.cell_longitude)
      formdata.append('latitude', this.form.cell_latitude)
      formdata.append('cell_type', this.form.cell_type)
      formdata.append('agri_prod', this.form.cell_prod)
      formdata.append('cell_name', this.form.cell_name)
      formdata.append('user_name', window.sessionStorage.getItem('username'))
      this.axios.post(this.$store.state.ip + 'celldef/addCell', formdata,
        {
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        // console.log(res)
        this.$message.success('生产单元添加成功')
        this.form = {}
      }).catch(err => {
        console.log(err)
        this.$message.success('生产单元添加失败')
      })
    },
    getCellProd () {
      this.axios.get(this.$store.state.ip + 'celldef/listAgriProducts',
        {
          params: {'celltype': this.form.cell_type},
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        this.listCellProd = res.data.data
        // console.log(res.data.data)
      }).catch(err => {
        console.log(err)
      })
    },
    cancel () {
      this.form = {}
    }
  },
  created () {
    this.axios.get(this.$store.state.ip + 'celldef/listCellTypes',
      {
        headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
      }).then(res => {
      this.listCellType = res.data.data
      // console.log(res.data.data)
    })
  },
  watch: {
    'form.cell_type': function () {
      if (this.form.cell_type !== ' ') {
        this.getCellProd()
      }
    }
  }
}
</script>

<style scoped>
.addPond_form {
  width: 450px;
  margin-left: 20px;
  margin-top: 30px;
}
.el-input, .el-select {
  margin-left: 10px;
  width: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/addPond.vue